import useDispensary from 'src/dispensary/hooks/use-dispensary';

/**
 * Hook to check if Kiosk Pro is enabled for the current dispensary.
 * Replaces the LaunchDarkly flag 'growth.ecomm.kiosk-pro-consumer-log-in.rollout'
 * with a direct check against the dispensary's kiosk configuration.
 *
 * @returns {boolean} True if the dispensary has kioskConfig.type === 'PRO', false otherwise
 */
export function useKioskPro(): boolean {
  const { dispensary } = useDispensary();
  return dispensary?.kioskConfig?.type === 'PRO';
}
